import React, { createContext, useContext, useState, useEffect } from 'react';

const BibleContext = createContext();

export const BibleProvider = ({ children }) => {
    const [bibleData, setBibleData] = useState(null);
    const [bibleDataEn, setBibleDataEn] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            import('./bibleData'),
            import('./bibleDataEn'),
        ]).then(([zhModule, enModule]) => {
            setBibleData(zhModule.bibleChapters);
            setBibleDataEn(enModule.bibleChapters);
            setLoading(false);
        });
    }, []);

    return (
        <BibleContext.Provider value={{ bibleData, bibleDataEn, loading }}>
            {children}
        </BibleContext.Provider>
    );
};

export const useBible = () => {
    const context = useContext(BibleContext);
    if (!context) {
        throw new Error('useBible must be used within a BibleProvider');
    }
    return context;
};